import type {DataViewerFilterClearConfig} from "~/components/ottopilotDataViewer/dataViewerFilterClearConfig";
import type {FilterConfiguration} from "~/components/ottopilotDataViewer/filterConfiguration";

/**
 * Amaron journeys / in-queue / disposition tracker: baseline lead-assignment filters
 * are mandatory and must not count as user-applied filters for the Clear button.
 */
export function buildAmaronJourneyFilterClearConfig(args: {
    leadViewFilterLineItems: FilterConfiguration["lineItems"];
    /** When false (In Queue), only user-applied filters and search enable Clear. */
    preserveLeadViewBaseline: boolean;
}): DataViewerFilterClearConfig {
    const preservedFilterLineItems =
        args.preserveLeadViewBaseline === true && args.leadViewFilterLineItems.length > 0
            ? [...args.leadViewFilterLineItems]
            : [];

    return {
        preservedFilterLineItems:
            preservedFilterLineItems.length > 0 ? preservedFilterLineItems : undefined,
        hasClearableFilters: (context) => {
            if (context.clearableFilterLineItems.length > 0) {
                return true;
            }
            return context.searchConfiguration.searchValue.trim() !== "";
        },
    };
}
